import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'

export default function LandingPagePreview({ landingPage, url }) {
    return (
        <Paper className='paper-padding-24'>
            <div className='quickFlex mar-b24' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <h4>Preview</h4>
                <div className='quickFlex' style={{ gap: 12 }}>
                    <Button
                        to={`/cp/templates/add/dragDropv2/?landingPageId=${landingPage.id}`}
                        iconLeft={<Icons icon='pencil' />}
                        postHogTag='landing-page-overview-edit'
                    >
                        Edit
                    </Button>
                    <Button
                        iconLeft={<Icons icon='eye' />}
                        href={url + '?preview=true'}
                        target='_blank'
                        postHogTag='landing-page-overview-preview'
                    >
                        Preview
                    </Button>
                </div>
            </div>
            <div style={{ position: 'relative' }}>
                <iframe
                    src={url + '?preview=true'}
                    height='600px'
                    width='100%'
                    style={{ height: 600, borderRadius: 12, border: 0 }}
                />
                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        background: 'transparent',
                        zIndex: 1,
                        top: 0,
                        left: 0,
                        position: 'absolute'
                    }}
                ></div>
            </div>
        </Paper>
    )
}
